import React from 'react';
import { testIds } from 'constants/test-constants';
import { useThemeContext } from 'contexts';
import { ThemeNames } from 'types/themes';

export default function Gradient() {
  const { themeName } = useThemeContext();
  const isExpTheme = themeName && themeName !== ThemeNames.ZOOCASA;
  const color = isExpTheme ? '#1B489B' : '#4695c4';

  return (
    <svg style={{ height: 0 }} data-testid={testIds.chartGradient} >
      <defs>
        <linearGradient id="chartGradient" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopOpacity="90" stopColor={color} />
          <stop offset="95%" stopOpacity="0" stopColor={color} />
        </linearGradient>
      </defs>
    </svg>
  );
}